"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    Globalize.addCultureInfo("en", {
        messages: {
            Dialog_Close: "Close the dialog",
            Dialog_DefaultButton: "Invoke default button",
            Dialog_HelpToolTip: "Help",
            Dialog_HideToolTip: "Hide",
        },
    });
    var controls;
    (function (controls) {
        /**
         * Framework base class for dialog form controls
         * @internal
         */
        var Dialog = /** @class */ (function (_super) {
            __extends(Dialog, _super);
            function Dialog(data, element, parent, role) {
                var _this = _super.call(this, data, element, parent, role) || this;
                _this.dynLayoutHeight = undefined;
                _this.canGoBack = $dyn.observable(false);
                // Dialog can be hidden and not closed in some cases, like when they are in the aside pane
                _this._canHide = $dyn.observable(false);
                _this.shouldDisplayHelpIcon = $dyn.observable(true);
                $dyn.observe(_this.IsActive, function (newValue) {
                    if (newValue && !_this.canActivate) {
                        // If trying activate and you can't then ensured that it is closed?
                        $dyn.shell.close({ form: _this });
                    }
                    else if (newValue) {
                        // Ensure that if the form was previously closed then it is now open
                        _this.willBeClosed = false;
                        _this.IsOpen(true);
                    }
                });
                $dyn.deferred.onTrue(function () { return $dyn.value(_this.IsActive); }).done(function () {
                    _this._zoomModeHeightObserver = $dyn.observe($dyn.shell.zoomModeHeight, function (inZoom) {
                        if (_this.IsActive()) {
                            if (inZoom && $dyn.value(_this.LayoutHeight) === $dyn.layout.Size.available) {
                                _this.dynLayoutHeight = $dyn.value(_this.LayoutHeight);
                                $dyn.setValue(_this, "LayoutHeight", $dyn.layout.Size.content);
                            }
                            else if (!inZoom && _this.dynLayoutHeight !== undefined) {
                                $dyn.setValue(_this, "LayoutHeight", _this.dynLayoutHeight);
                                // clear out old
                                _this.dynLayoutHeight = undefined;
                            }
                        }
                    });
                });
                _this.shouldCloseOnClick = function (options) {
                    // Explicitly do not close if currently active and the user clicked outside the dialog. If self isn't currently active,
                    // a user click doesn't dismiss it (it may dismiss a dialog on top of it, for example).
                    if (_this.IsActive() && options.flyoutElement && options.flyoutElement.length > 0 && !$.contains(options.flyoutElement[0], options.clickTarget)) {
                        return undefined;
                    }
                };
                return _this;
            }
            Dialog.prototype.Open = function () {
                this.IsOpen(true);
            };
            Dialog.prototype.hide = function () {
                if (this._onHide) {
                    this._onHide.apply(this, arguments);
                }
            };
            Dialog.prototype.onHide = function (hideCallback) {
                if (hideCallback === null) {
                    this._canHide(false);
                    this._onHide = null;
                }
                else if (hideCallback) {
                    this._canHide(true);
                    this._onHide = hideCallback;
                }
            };
            // Override the Form's ObserveFactBoxes since those do not apply to this sub form type
            Dialog.prototype.ObserveFactBoxes = function () { };
            Dialog.prototype._close = function () {
                // Set the flag that the dialog is closing
                this.willBeClosed = true;
                // Should we be setting is active here?
                this.IsActive(false);
                // clear observable
                if (this._zoomModeHeightObserver) {
                    this._zoomModeHeightObserver.dispose();
                    this._zoomModeHeightObserver = undefined;
                }
                // If a close callback has been set on this form, call it to notify it that the form has closed
                if (this.closeCallback) {
                    $dyn.getFunction(this.closeCallback)();
                }
            };
            /** @internal used from HTML template */
            Dialog.prototype.openHelp = function () {
                $dyn.shell.openHelpPane();
            };
            /** @obsolete unused? */
            Dialog.prototype._back = function () {
                this.back.apply(this, arguments);
            };
            return Dialog;
        }($dyn.controls.Form));
        controls.Dialog = Dialog;
        Dialog.prototype.back = $dyn.shell.dialogBack;
        Dialog.prototype.TypeName = "Dialog";
        // tslint:disable:object-literal-sort-keys
        var DialogShortcuts = {
            DefaultAction: {
                Keys: { keyCode: $dyn.ui.KeyCodes.enter },
                Handler: function (evt) {
                    // If a form is being rendered as a dialog and has DefaultAction specified, it will take precedence over DefaultButton.
                    this.executeDefaultActionOrDefaultButton(evt);
                },
                ShowToUser: false,
            },
            DefaultActionAlternate: {
                Keys: { alt: true, keyCode: $dyn.ui.KeyCodes.enter },
                Handler: function (evt) {
                    // If a form is being rendered as a dialog and has DefaultAction specified, it will take precedence over DefaultButton.
                    this.executeDefaultActionOrDefaultButton(evt);
                },
                Description: function () {
                    var description = "";
                    if ($dyn.value(this.DefaultActionEnabled)) {
                        description = $dyn.label("Form_DefaultAction");
                    }
                    else {
                        description = $dyn.label("Dialog_DefaultButton");
                    }
                    return description;
                },
            },
            Escape: {
                Keys: { keyCode: $dyn.ui.KeyCodes.esc },
                Handler: function (evt) {
                    // When using this shortcut from an element just edited, the control may not have the latest value
                    var control = evt ? $dyn.context(evt.target) : undefined;
                    if (control && control.updateValue) {
                        control.updateValue(true);
                    }
                    this.AllowSave($dyn.shell.initiateBack);
                },
                Description: $dyn.label("Dialog_Close"),
                Category: $dyn.ui.ShortcutCategory.Close,
            },
        };
        Dialog.prototype.Shortcuts = $dyn.extendPrototype(Dialog.prototype.Shortcuts, DialogShortcuts);
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=Dialog.js.map
